import { useContext } from 'react';
import { LoadSettingContext } from "../utils";
export const useSetting = (key) => {
    var _a, _b;
    const settings = useContext(LoadSettingContext);
    if (settings) {
        return (_b = (_a = settings.find((e) => e.key === key)) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : undefined;
    }
    return undefined;
};
//# sourceMappingURL=useSetting.js.map